import { useSearchParams } from 'react-router-dom'
import { GradientSeparator } from './GradientSeparator'
import { FilterTopBar } from './FilterTopBar'
import Ratings from 'cwp-components/utils/Ratings'
import { DropdownFilters } from './DropdownFilters'
import RangeFilters from './RangeFilters'
import { ClearFiltersButton } from './ClearFiltersButton'
import { FindLegalDocument } from './FindLegalDocument'

interface FiltersPanelProps {
  setFiltersVisible: (isVisible: boolean) => void
  metaData: any
}

export const FiltersPanel = ({
  setFiltersVisible,
  metaData,
}: FiltersPanelProps) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const selectedUserRating = searchParams.get('user_rating')

  return (
    <div className='z-50 absolute left-5 right-5 lg:left-10 lg:right-10 xl:left-20 xl:right-20 top-4 max-w-[1220px] p-[30px] rounded-lg border-[0.6px] border-[#D9E0DF] bg-white shadow-[0px_2px_20px_0px_rgba(187,199,215,0.2)]'>
      <FilterTopBar onClick={() => setFiltersVisible(false)} />
      <GradientSeparator />
      <div className='mt-8 flex justify-center md:justify-between flex-wrap gap-y-6'>
        <DropdownFilters />
        <RangeFilters metaData={metaData} />
        <div className='w-full md:w-[30%] flex flex-col items-end space-y-6'>
          <div className='w-full flex flex-col items-center mt-[30px] md:mt-0'>
            <h1 className='text-sm font-medium mb-2 text-center'>
              Customer satisfaction
            </h1>
            <Ratings
              label='satisfied'
              rating={parseInt(selectedUserRating)}
              setRating={(value) =>
                setSearchParams((prev) => {
                  const newParams = new URLSearchParams(prev.toString())
                  newParams.set('user_rating', value.toString())
                  return newParams
                })
              }
            />
          </div>
        </div>
        <div className='mt-[30px] md:hidden flex flex-col gap-4'>
          <ClearFiltersButton />
          <FindLegalDocument />
        </div>
      </div>
    </div>
  )
}
